window.BAO.ProductForm = class ProductForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
  }

  checkValidity () {
    window.setTimeout(() => {
      super.checkValidity()

      if (!this.form) {
        this.throwError(`needs to be wrapped around a product's <form> element`)
      }
    }, 500)
  }

  async onSubmitHandler (e) {
    e.preventDefault()
    await this.addToCart()
    if (window.location.pathname === `/cart`) {
      window.location.reload()
    }
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form)
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', window.BAO.ProductForm)
}
